import React from 'react'
import { CurrencyText } from '../../../Global'

export const TableDataCellCpm = ({ dataValue }: { dataValue?: number }) => {
  return <CurrencyText value={Number(dataValue)} />
}
